const CentreonIcon = ({ className }) => {
	return (
		<svg
			className={className}
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			{/* Outer C curve */}
			<path
				d="M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c2.21 0 4.21-0.89 5.65-2.34"
				stroke="currentColor"
				strokeWidth="3"
				strokeLinecap="round"
				fill="none"
				className="opacity-80"
			/>

			{/* Inner C curve */}
			<path
				d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c1.38 0 2.63-0.56 3.54-1.46"
				stroke="currentColor"
				strokeWidth="3"
				strokeLinecap="round"
				fill="none"
				className="opacity-100"
			/>
		</svg>
	);
};

export default CentreonIcon;
